<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-添加活动
      -->
  <div>
    <div class="product-content">
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <el-form-item label="发送对象">
          <el-radio v-model="form.send_type" :label="1">全站会员</el-radio>
          <el-radio v-model="form.send_type" :label="2">会员等级</el-radio>
          <el-radio v-model="form.send_type" :label="3">指定会员</el-radio>
        </el-form-item>
        <el-form-item label="选择会员等级" v-if="form.send_type == 2">
          <el-select v-model="form.user_level" placeholder="请选择">
            <el-option v-for="(item, index) in grade" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择会员" v-if="form.send_type == 3">
          <div class="d-s-s d-c">
            <el-button @click="openGetuser" icon="el-icon-plus">选择会员</el-button>
            <ul class="d-s-s select-user">
              <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in select_list" :key="index">
                  <img :src="item.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{item.nickName}}</p>
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="商品管理" prop="tableData" :rules="rulesProduct">
          <el-button icon="el-icon-plus" @click="changeProduct(form.tableData)">选择商品</el-button>
          <div class="pt16">
            <el-table size="mini" :data="form.tableData" border style="width: 100%;">
              <el-table-column label="商品名称" width="300">
                <template slot-scope="scope">
                  <p class="text-ellipsis-2">{{ scope.row.product_name }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="product_price" label="售价"></el-table-column>
              <el-table-column prop="assemble_price" label="拼团价"></el-table-column>
              <el-table-column prop="send_num" label="赠送数量">
                <template slot-scope="scope">
                  <el-input size="small" type="number" min="1" :class="{ isvalid: scope.row.send_numValid == true }" :rules="[{ required: true, message: '请填写赠送数量' }]" v-model="scope.row.send_num"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!--选择用户-->
    <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>

    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import AssembleApi from '@/api/assemble.js';
import GetUser from '@/components/user/GetUser.vue';
import Product from '@/components/assemble/Product.vue';
export default {
  components: {
    GetUser,
    Product
  },
  data() {
    /*验证名称*/
    const validatorProduct = (rule, value, callback) => {
      if (value.length < 1) {
        return callback(new Error('请选择商品'));
      } else {
        let error_price = false;
        for (let i = 0; i < this.form.tableData.length; i++) {
          let item = this.form.tableData[i];
          if (parseInt(item.send_num) > 0) {
            item.send_numValid = true;
          } else {
            item.send_numValid = false;
          }

          this.$set(this.form.tableData, i, item);
        }
        callback();
      }
    };
    return {
      form: {
        send_type: 1,
        user_level: '',
        tableData: [],
      },
      /*是否打开选择商品*/
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      /*用户等级列表*/
      grade: {},
      /*获取用户是否显示*/
      open_getuser: false,
      select_list: [],
      /*验证商品*/
      rulesProduct: [{ validator: validatorProduct, required: true, trigger: 'blur' }],
      /*判断是否正在加载*/
      loading: false,
    };
  },
  created() {
     this.getGradeList();
  },
  methods: {
    /*获取等级*/
    getGradeList() {
      let self = this;
      AssembleApi.toSendCoupon({}, true)
        .then(data => {
          self.grade = data.data.list;
        })
        .catch(error => {});
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.assemble_product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          console.log(item)
          let obj = {
            product_name: item.product.product_name,
            product_id: item.product_id,
            product_price: item.assembleproductsku.product_price,
            assemble_price: item.assembleproductsku.assemble_price,
            active_title: item.active.title,
            assemble_activity_id: item.assemble_activity_id,
            assemble_product_id: item.assemble_product_id,
            // assemble_product_sku_id: item.assembleproductsku.assemble_product_sku_id,
            send_num: 1,
          };
          arr.push(obj);
        }
        self.form.tableData = self.form.tableData.concat(arr);
        // self.form.tableData = mergeTable(this.form.tableData);
      }
    },

    /*打开获取用户*/
    openGetuser() {
      this.open_getuser = true;
    },

    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != 'error') {
        this.select_list=this.select_list.concat(e.params);
      }
      this.open_getuser = false;
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.form.product_list = self.tableFormet(self.form.tableData);
          let params = self.form;

          if(params.send_type == 3){
            let user_ids=[];
            self.select_list.forEach((item)=>{
              user_ids.push(item.user_id);
            })
            params.user_ids=user_ids.join(',');
          }

          delete params.tableData;
          self.loading = true;
          AssembleApi.sendCoupon(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，发送成功',
                type: 'success'
              });
              self.$router.push('/plus/assemble/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*表格数据格式化*/
    tableFormet(list) {
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          assemble_activity_id: item.assemble_activity_id,
          assemble_product_id: item.assemble_product_id,
          // assemble_product_sku_id: item.assemble_product_sku_id,
          send_num: item.send_num,
        };
        newList.push(obj);
      }
      return newList;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/assemble/coupon/send.vue